import { forEach } from "lodash";
import {getTermsAndConditionsLink} from "../../constants";

const translation = {
  "button" : {
    "accept" : "Přijmout",
    "add" : "Přidat",
    "activate" : "Aktivovat",
    "addAttachment" : "Přidat přílohu",
    "addFile" : "Add File",
    "back" : "Zpět",
    "cancel" : "Zrušit",
    "change" : "Změnit",
    "chooseContact" : "Vyberte kontakt",
    "chooseOther" : "Vyberte jiné",
    "chooseProject" : "Vyberte projekt",
    "close" : "Zavřít",
    "closeRequest" : "Uzavřít",
    "comment" : "Okomentovat",
    "confirm" : "Potvrdit",
    "createNewProject" : "Vytvořit nový projekt",
    "dateFilter" : "Filtr na datum",
    "dismiss" : "Zamítnout",
    "enter" : "Vložit",
    "enterReceivedRequest" : "Zadat přijatý požadavek",
    "filter" : "Filtr",
    "invite" : "Pozvat",
    "inviteProvider" : "Pozvat dodavatele",
    "modify" : "Změnit...",
    "more" : "Více",
    "newRequest" : "Nový požadavek",
    "next" : "Další",
    "no" : "Ne",
    "notSolved" : "Nevyřešené",
    "ok" : "OK",
    "previous" : "Předchozí",
    "projectDetail" : "Detail projektu",
    "reject" : "Odmítnout",
    "removeAttachment" : "Odebrat přílohu",
    "removeFile" : "Remove File",
    "resolved" : "Vyřešeno",
    "resolving" : "Vyřešeno",
    "resubmit" : "Znovu předat",
    "return" : "Vrátit",
    "search" : "Hledat",
    "send" : "Poslat",
    "sendNewRequest" : "Zadat nový požadavek",
    "sendSecureMessage" : "Poslat zabezpečenou zprávu",
    "setupOrganization" : "Nastavit novou organizaci",
    "showAll" : "Zobrazit vše",
    "showLess" : "Zobrazit méně",
    "showProvider" : "Zobrazit dodavatele",
    "signin" : "Přihlásit",
    "signup" : "Registrovat",
    "submit" : "Odeslat",
    "yes" : "Ano"
  },
  "menu" : {
    "signOut" : "Odhlásit",
    "editAccount" : "Upravit účet",
    "apps" : {
      "requests" : "Požadavky",
      "contacts" : "Kontakty"
    }
  },
  "formLabel" : {
    "address" : "Adresa",
    "address2" : "Adresa 2",
    "annexes" : "Dodatky",
    "apiKey" : "API klíč",
    "attachFile" : "Attach File",
    "attachments" : "Přílohy",
    "city" : "Město",
    "company" : "Společnost",
    "comment" : "Komentář",
    "companyIndustry" : "Odvětví společnosti",
    "companySize" : "Velikost společnosti",
    "confirm" : "Potvrzení hesla",
    "country" : "Země",
    "contact" : "Kontakt",
    "date" : "Datum",
    "dateCreated" : "Datum vytvoření",
    "dateUpdated" : "Datum změny",
    "description" : "Popis",
    "email" : "Email",
    "emailIdent" : "E-mail",
    "estimatedDuration" : "Odhadované trvání",
    "firstName" : "Křestní jméno",
    "label" : "Označení",
    "lastName" : "Příjmení",
    "logo" : "Logo",
    "messageSecurity" : "Zabezpečení zprávy",
    "messageSubject" : "Předmět zprávy",
    "name" : "Jméno",
    "newPassword" : "Nové heslo",
    "newProjectSubject" : "K vytvoření nového projektu",
    "newMemberEmail" : "Email nového člena",
    "oldPassword" : "Staré heslo",
    "onBehalfOf" : "Jménem",
    "organizationName" : "Název organizace",
    "organizationIdent" : "Identifikátor organizace",
    "password" : "Heslo",
    "permission" : "Oprávnění",
    "picture" : "Obrázek",
    "price" : "Cena",
    "priceTax" : "Daň",
    "privateBody" : "Soukromé sdělení",
    "project" : "Projekt",
    "projectDescription" : "Popis projektu",
    "projectName" : "Název projektu",
    "projectSponsor" : "Sponzor projektu",
    "provider" : "Dodavatel",
    "repeatPassword" : "Zopakujte heslo",
    "requestFrom" : "Požadavek od",
    "requestId" : "ID požadavku",
    "requestSeverity" : "Vážnost požadavku",
    "requestSource" : "Zdroj požadavku",
    "requestSubject" : "Předmět požadavku",
    "requestType" : "Typ požadavku",
    "resolveRequest" : "Řešení požadavku",
    "sendRequestTo" : "Poslat požadavek",
    "sendTo" : "Komu poslat",
    "sendToSponsor" : "Poslat požadavek sponzorovi projektu",
    "severity" : "Vážnost",
    "solver" : "Řešitel",
    "status" : "Status",
    "subject" : "Předmět",
    "suggestedProviders" : "Navržení dodavatelé",
    "surname" : "Příjmení",
    "thumbnail" : "Ikonka",
    "to" : "Komu",
    "twitter" : "Twitter",
    "uploadFile" : "Nahrát soubor",
    "value" : "Hodnota",
    "visibleMessageSubject" : "Viditelný předmět zprávy",
    "websiteAddress" : "Web",
    "zip" : "PSČ"
  },
  "formValue" : {
    "loading" : "[Načítám...]",
    "none" : "žádné",
    "apiKeyRequestPermission" : {
      "create" : "Pouze vytvářet požadavky",
      "full" : "Neomezený přístup"
    },
    "duration": {
      "day" : "__count__ den",
      "day_plural_2" : "__count__ dny",
      "day_plural_5" : "__count__ dnů",
      "hour" : "__count__ hodina",
      "hour_plural_2" : "__count__ hodiny",
      "hour_plural_5" : "__count__ hodin",
      "minute" : "__count__ minuta",
      "minute_plural_2" : "__count__ minuty",
      "minute_plural_5" : "__count__ minut",
      "units" : "dny:hodiny:minuty"
    },
    "messageSecurity" : {
      "normal" : "Normální"
    },
    "priceTax" : {
      "excluding" : "Bez daně",
      "including" : "Včetně daně"
    },
    "project" : {
      "none" : "Žádný projekt"
    },
    "projectStatus" : {
      "active" : "Aktivní"
    },
    "provider" :{
      "selectValue" : "Vyberte dodavatele..."
    },
    "requestType" : {
      "demand" : "Požadavek",
      "bug" : "Chyba",
      "extension" : "Rozšíření",
      "general" : "Obecné",
      "enquiry" : "Poptávka",
      "complaint" : "Stížnost"
    },
    "requestSeverity" : {
      "lowest" : "Nejnižší",
      "low" : "Nízká",
      "normal" : "Normální",
      "high" : "Vyšší",
      "highest" : "Nejvyšší"
    },
    "requestStatus" : {
      "pending" : "Nevyřízený",
      "accepted" : "Akceptován",
      "closed" : "Uzavřen",
      "dismissed" : "Zamítnut",
      "resolving" : "Vyřešen, k potvrzení",
      "resolved" : "Vyřešen"
    },
    "dateSelect" : {
      "created" : "Datum vytvoření",
      "modified" : "Datum změny"
    },
    "dateRange" : {
      "today" : "Dnes",
      "yesterday" : "Včera",
      "thisWeek" : "Tento týden",
      "lastWeek" : "Minulý týden",
      "last7Days" : "Posledních 7 dní",
      "last14Days" : "Posledních 14 dní",
      "last30Days" : "Posledních 30 dni",
      "thisMonth" : "Tento měsíc",
      "lastMonth" : "Minulý měsíc",
      "any" : "Kdykoli"
    },
    "selectProvider" : "Vybrat dodavatele"
  },
  "formHint" : {
    "requestComment" : "Požadavek o informace, spolupráci nebo pouze komentář o tom, co se děje.",
    "selectProject" : "Vyberte projekt ze seznamu.",
    "selectProvider" : "Vyberte dodavatele ze seznamu.",
    "switchIdentity" : {
      "1" : "Nesprávný účet?",
      "link" : "[Přepnout identitu]"
    },
    "title" : "Zde napište shrnutí vašeho požadavku",
    "messageSubject" : "Zde napište předmět vaší zprávy",
    "projectName" : "Zde napište název projektu",
    "search" : "Hledat požadavky",
    "switchIdentityDialogTitle": "Změnit identitu",
    "switchIdentityDialogMessage":"Opravdu chcete změnit svou identitu?"
  },
  "dateFormat" : {
    "today" : "Dnes",
    "yesterday" : "Včera"
  },
  "status" : {
    "initializing" : "Inicializuji...",
    "uploading" : "Nahrávám…",
    "finishingUpload" : "Dokončuji nahrávání. Počkejte prosím...",
    "noRequests" : "Nejsou žádné požadavky v seznamu.",
    "noRequestsForMe" : "Žádné požadavky na mě nečekají.",
    "noRequestsForThem" : "Žádné požadavky na ně nečekají.",
    "noContacts" : "V seznamu nejsou žádné kontakty."
  },
  "requestComment" : {
    "removedAttachment" : "Příloha '__filename__' byla odstraněna."
  },
  "featureNotFinishedDialog" : {
    "message" : "Momentálně nedostupné",
    "description" : "Omlouváme se za vzniklé potíže. Usilovně pracujeme na zprovoznění této funkcionality."
  },
  "general" : {
    "unexpectedError" : {
      "message" : "Vyskytla se neočekávaná chyba",
      "description" : "Omlouváme se za vzniklé potíže. Dejte nám prosím prosím vědět za jakých podmínek se tak stalo a my se je pokusíme opravit tak rychle, jak jen to půjde."
    },
    "termsAndConditionsLink" : getTermsAndConditionsLink() // "http://www.atollon.cz/podminky/atollon.com"
  },
  "breadCrumbs" : {
    "home" : "atollon.com Domů",
    "requests" : "Požadavky",
    "projects" : "Projekty"
  },
  "validation" : {
    "fieldRequired" : "Vyplnění pole je vyžadováno.",
    "invalidEmail" : "Zadejte platnou e-mailovou adresu.",
    "duration" : "Zadané trvání není platné. Zadejte prosím číslo mezi 0 a 99,999.",
    "priceAmount" : "Zadaná cena není platná. Zadejte prosím číslo mezi 0 a 999,999,999,999.99.",
    "priceTax" : "Zadaná sazba není platná. Zadejte prosím číslo mezi 0 a 99."
  },
  "fileUpload" : {
    "unsupportedFile" : {
      "message" : "Tento soubor není podporován.",
      "description" : "Tento typ souboru není podporován. Prosím vyberte jiný."
    },
    "uploadFailed" : {
      "message" : "Nahrání souboru selhalo.",
      "description" : "Soubor '__filename__' nemohl být nahrán.\nUbezpečte se prosím, že je soubor čitelný, není prázdný a má správný formát."
    },
    "status" : {
      "waitingFile" : "Ve frontě: __filename__",
      "uploadingFile" : "Nahrávám soubor '__filename__'. Chvíli strpení…",
      "uploadedFile" : "Uspešně nahrán soubor '__filename__'.",
      "noFileAttached" : "<žádný soubor>"
    }
  },

  "signup" : {
    "title" : "Atollon - Vytvořte si účet",
    "headerText" : "Vytvořte si účet",
    "agreeWithTerms" : {
      "1" : "Přečetl jsem a přijímám",
      "link" : "Podmínky užití."
    },
    "signin" : {
      "1" : "Už máte účet? Prosím",
      "link" : "Přihlaste se"
    },
    "registrationFailed" : {
      "message" : "Registrace selhala",
      "invalidValues" : "Registrační formulář obsahuje neplatné hodnoty nebo nevyplněná povinná pole."
    },
    "registrationSucces" : {
      "message" : "Děkujeme za registraci!",
      "description" : "Byl vám odeslán email s instrukcemi k ověření a dokončení registrace."
    },
    "validation" : {
      "emptyValues" : "Pole je vyžadované.",
      "invalidEmail" : "Zadána chybná emailová adresa.",
      "invalidPassword" : "Zadaná hesla se neshodují.",
      "userExists" : "Zadaná emailová adresa je již registrována.",
      "userChecking" : "Oveřuji emailovou adresu.",
      "invalidAgreeTerms" : "Musíte potvrdit souhlas s podmínkami užití."
    },
    "request" : {
      "subject" : "Registrace uživatele",
      "messageBody" : "Přijměte prosím mou registraci a vytvořte mi uživatelský účet identifikovaný mou emailovou adresou."
    },
    "serverError" : {
      "message" : "Chyba serveru",
      "description" : "Nastala chyba serveru. Omlouváme se za vzniklé problémy.\nZkuste to znovu později."
    }
  },
  "signin" : {
    "title" : "Atollon - Přihlaste se",
    "headerText" : "Přihlaste se",
    "forgotPassword" : "Zapomněli jste heslo?",
    "keepLogged" : "Chci zůstat přihlášen(a).",
    "notYetRegistered" : "Ještě nemáte Atollon.com účet?",
    "createAccount" : "Vytvořte si účet zdarma",
    "emptyUsername" : "Zadejte prosím emailovou adresu vašeho účtu na atollon.com.",
    "emptyPassword" : "Zadejte prosím heslo k vašemu účtu.",
    "emptyValues" : {
      "message" : "Nelze se přihlásit.",
      "description" : "Emailová adresa nebo heslo nejsou zadané."
    },
    "loginFailed" : "Přihlášení se nezdařilo. Zadaný email nebo heslo nejsou správně."
  },
  "forgotPassword" : {
    "title" : "Atollon - Zapomněli jste heslo?",
    "headerText" : "Zapomněli jste heslo?",
    "message" : "V případě, že jste zapomněli heslo, vložte prosím svůj email a odešlete požadavek na změnu hesla.",
    "recallPassword" : "Vzpomněli jste si na své heslo?",
    "pleaseLogin" : "Prosím, prihlaste se",
    "validation" : {
      "emptyEmail" : "Email je vyžadován.",
      "imvalidEmail" : "Pro zadanou adresu neexistuje žádný účet."
    },
    "invalidForm" : {
      "message" : "Byly zadané neplatné hodnoty.",
      "description" : "Prosím, vložte platnou emailovou adresu."
    },
    "passwordSent" : {
      "message" : "Požadavek odeslán.",
      "description" : "Na emailovou adresu __email__  byla zaslána zpráva s instrukcemi jak změnit heslo pro účet vázaný na tuto emailovou adresu."
    }
  },
  "changePassword" : {
    "title" : "Atollon - Změnit heslo",
    "headerText" : "Změnit heslo",
    "contents" : {
      "0" : "Chystáte se změnit heslo pro uživatelský účet:",
      "1" : "Pokud jste nezadali tento požadavek, nebo si prostě nechcete změnit heslo, pak byste jej měli odmítnout."
    },
    "invalidUrl" : {
      "title" : "Neplatná URL",
      "descritpion" : "Pokud jste se sem dostali z odkazu uvedeného v e-mailové zprávě, odkaz již byl použit a není nadále platný."
    },
    "request" : {
      "subject" : "Změna hesla",
      "messageBody" : "Změňte prosím heslo mého uživatelského účtu."
    },
    "invalidForm" : {
      "message" : "Heslo není možné změnit",
      "description" : "Formulář obsahuje neplatné hodnoty."
    },
    "success" : {
      "message" : "Heslo změněno",
      "description" : "Heslo bylo úspěšně změněno. Při přístím přihlašování použijte toto nové heslo."
    },
    "validation" : {
      "differntPasswords" : "Hesla nejsou shodná.",
      "emptyPassword" : "Heslo nemůže být prázdné."
    }
  },
  "activateAccount" : {
    "title" : "Atollon - Aktivovat účet Atollon.com",
    "headerText" : "Aktivovat účet Atollon.com",
    "contents" : {
      "0" : "Chystáte se aktivovat svůj nový uživatelský účet:",
      "1" : "Pokud jste nezadali tento požadavek nebo pouze nechcete aktivovat účet, pak byste ho měli odmítnout."
    },
    "invalidUrl" : {
      "title" : "Neplatné URL",
      "descritpion" : "Pokud jste se sem dostal(a) z odkazu v e-mailové zprávě, pak byl tento odkaz již použit a není platný."
    },
    "success" : {
      "message" : "Uživatelský účet byl aktivován.",
      "description" : "Váš nový účet Atollon.com byl úspěšně aktivován. Vítejte v Atollon.com!"
    }
  },
  "contacts" : {
    "title" : "Atollon - Kontakty",
    "header" : {
      "allContacts" : "Všechny kontakty",
      "providers" : "Dodavatelé",
      "clients" : "Klienti"
    },
    "filter" : {
      "allContacts" : "Všechny kontakty",
      "providers" : "Dodavatelé",
      "myProviders" : "Moji dodavatelé",
      "clients" : "Klienti",
      "myClients" : "Moji klienti"
    }
  },
  "requests" : {
    "title" : "Atollon - Požadavky",
    "headerText" : "Požadavky",
    "waitingForMe" : "Požadavky čekající na mě",
    "waitingForThem" : "Požadavky čekající na ně",
    "allRequests" : "Všechny požadavky",
    "filter" : {
      "waitingForMe" : "Čeká na mě",
      "waitingForThem" : "Čeká na ostatní",
      "allRequests" : "Všechny požadavky",
      "contacts" : "Kontakty",
      "projects" : "Projekty",
      "clearContact" : "Vyčistit filtr kontaktů",
      "clearProject" : "Vyčistit filtr projektů"
    },
    "selectProjectDialog" : {
      "header" : "Vybrat projekt",
      "emptyList" : "Nejsou žádné projekty, u kterých bych byl členem nebo správcem."
    },
    "selectContactDialog" : {
      "header" : "Vybrat kontakt",
      "emptyList" : "Nejsou tu žádné kontakty, ze kterých by bylo možné vybírat."
    },
    "invalidSearch" : {
      "message" : "Vyhledávací řetězec má nepodporovaý formát.",
      "description" : "Vyhledávací řetězec by měl obsahovat pouze slova oddělená mezerami. Nepoužívejte znaky '(', ')' (závorky), '&' (and), '|' (pipe) a '!' (vykřičník), jelikož mají specifický význam."
    }
  },
  "home" : {
    "title" : "Atollon - Můj panel",
    "headerText" : "Můj panel",
    "waitingForMe" : "Čeká na mě",
    "waitingforThem" : "Čeká na ostatní",
    "myProjects" : "Moje projekty",
    "myProviders" : "Moji dodavatelé",
    "myOrganization" : "Moje organizace",
    "createNewProject" : "Založit nový projekt"
  },
  "projectDetail" : {
    "title" : "Atollon projekt - __project__",
    "waitingForMe" : "Čeká na mě",
    "waitingforThem" : "Čeká na ostatní",
    "projectMembers" : "Členové projektu",
    "projectAdmins" : "Správci projektu",
    "projectSponsor" : "Sponzor projektu",
    "addAdmin" : "Přidat správce projektu",
    "addMember" : "Přidat člena projektu",
    "removeMemberConfirm" : {
      "message" : "Odstranit člena '__member__'?",
      "description" : "Jste si jist(á), že chcete odstranit z projektu projektu člena: '__member__'?"
    },
    "duplicateMember" : {
      "message" : "Člen projektu '__member__' je již přidán.",
      "description" : "Člen projektu '__member__' je již přidaný do seznamu členů projektu ve stejné roli."
    },
    "enterValidEmailAddress" : "Zadejte prosím platnou e-mailovou adresu.",
    "addMemberFieldLabel" : "E-mailová adresa člena pro přidání"
  },
  "newRequest" : {
    "title" : "Zaslat požadavek",
    "headerText" : "Nový požadavek",
    "invalid" : {
      "subject" : "Předmět požadavku musí být zadán.",
      "recipient" : "Příjemce musí být zadán.",
      "invalidRecipient" : "Příjemce musí být buď e-mailová adresa nebo položka vybraná z poskytnutého seznamu.",
      "cannotAttach" : "Příjemce musí být organizace, aby bylo možné přidávat přílohy."
    },
    "invalidForm" : {
      "message" : "Nemohu vytvořit nový požadavek.",
      "description" : "Formulář pro nový požadavek není správně vyplněn."
    },
    "annexes" : {
      "addProject" : "Add Project",
      "addAttachment" : "Add Attachment"
    }
  },
  "newProject" : {
    "title" : "Atollon - nový projekt",
    "headerText" : "Žádost o nový projekt",
    "invalid" : {
      "name" : "Prosím zadejte název projektu.",
      "recipient" : "Prosím vyberte sponzora projektu."
    },
    "invalidForm" : {
      "message" : "Nemohu vytvořit novou žádost o projekt.",
      "description" : "Formulář žádosti není správně vyplněn."
    },
    "requestBody" : "Přijetím této žádosti vytvoříte nový projekt.",
    "requestSubject" : "Vytvořit nový projekt: __project__"
  },
  "receivedRequest" : {
    "title" : "Atollon - Přijatý požadavek",
    "headerText" : "Nový přijatý požadavek",
    "invalidEmail" : "Odesílatel musí být zadán s platnou e-mailovou adresou."
  },
  "secureMessage" : {
    "title" : "Atollon - Zaslat bezpečnou zprávu"
  },
  "inviteProvider" : {
    "title" : "Pozvat našeho dodavatele",
    "headerText" : "Pozvat dodavatele",
    "requestSubject" : "Prosím připojte se k seznamu našich dodavatelů",
    "requestBody" : "Zdravím,\n\nrádi bychom, pokud byste se připojili k seznamu našich dodavatelů na Atollon.com.\n\nAtollon nám umožňuje třídit veškeré požadavky, které zasíláme svým dodavatelům, na jednom místě. Také nám pomáhá udržet si jasný přehled o stavu každého jednotlivého požadavku.\n\nBudeme rádi, pokud se připojíte k našim dodavatelům. Pokud doposud nemáte účet Atollon.com, nezabere Vám to více než 5 minut si ho zařídit zdarma a společně ušetříme mnoho času v budoucnosti.\n\nPředem Vám děkuji.\n\n__person__\n__company__",
    "validation" : {
      "subject" : "Předmět požadavku je vyžadován.",
      "body" : "Popis požadavku je vyžadován.",
      "emptyRecipient" : "Příjemce musí být zadán.",
      "invalidRecipient" : "Zadejte e-mailovou adresu příjemce"
    }
  },
  "inviteProjectMember" : {
    "title" : "Pozvat nového člena"
  },
  "requestDetail" : {
    "title" : "Atollon požadavek - __subject__",
    "headerText" : {
      "initialRecipientYour" : "Požadavek čekající na Vaše přijetí",
      "initialRecipientTheir" : "Požadavek čekající na přijetí",
      "initialSenderYour" : "Požadavek čekající na Vaše doplnění",
      "initialSenderTheir" : "Požadavek čekající na dodatečné doplnění",
      "acceptedRecipientYour" : "Požadavek čekající na Vaše řešení",
      "acceptedRecipientTheir" : "Požadavek čekající na vyřešení",
      "acceptedSenderYour" : "Požadavek čekající na Vaše doplnění",
      "acceptedSenderTheir" : "Požadavek čekající na dodatečné doplnění",
      "resolvingRecipientYour" : "Řešení odmítnuto, čekající na vyřešení",
      "resolvingRecipientTheir" : "Řešení odmítnuto, čekající na vyřešení",
      "resolvingSenderYour" : "Čeká se na Vaše potvrzení vyřešení",
      "resolvingSenderTheir" : "Čeká se na potvrzení vyřešení",
      "resolved" : "Požadavek potvrzený jako vyřešený",
      "dismissed" : "Požadavek nemohl být vyřešený",
      "closedRecipient" : "Požadavek uzavřen řešitelem",
      "closedSender" : "Požadavek vyřešen odesílatelem",
      "default" : "Požadavek"
    },
    "commentDialogLabel" : {
      "modify" : "Komentář ke změně požadavku",
      "fileRemove" : "Komentář k odstranění souboru '__filename__'",
      "return" : "Komentář při vrácení",
      "resubmit" : "Nový doplňující komentář",
      "reject" : "Odmítací komentář",
      "dismiss" : "Zamítací komentář",
      "accept" : "Komentář při přijetí",
      "close" : "Komentář při uzavření",
      "resolving" : "Komentář k řešení",
      "resolved" : "Komentář k vyřešení",
      "notResolved" : "Komentář k nevyřešení"
    },
    "emptyComment" : {
      "message" : "Prázdný komentář",
      "description" : "Prosím zadejte komentář. Nemůžete nezadat komentář."
    },
    "status" : {
      "accepted" : "Požadavek přijatý __date__ uživatelem __author__",
      "resolving" : "Požadavek vyřešený __date__ uživatelem __author__",
      "resolved" : "Požadavek potvrzený jako vyřešený __date__ uživatelem __author__",
      "closed" : "Požadavek uzavřen __date__ uživatelem __author__",
      "dismissed" : "Požadavek zrušen __date__ uživatelem __author__",
      "sender" : {
        "initial" : "Požadavek byl  __date__ vrácen zasilateli",
        "accepted" : "Požadavek byl odložen  __date__ a čeká na zasilatele",
        "resolving" : "Požadavek byl __date__ znovu zaslán zasilateli k přijetí řešení."
      },
      "recipient" : {
        "initial" : "Požadavek zaslán __date__ znovu příjemci",
        "accepted" : "Požadavek obnoven __date__ a zaslán příjemci",
        "resolving" : "Řešení požadavku nebylo přijato, požadavek byl __date__ vrácen příjemci"
      }
    },
    "validation" : {
      "invalidSolver" : "Vyberte hodnotu ze seznamu nebo zapište platnou e-mailovou adresu.",
      "emptyProvider" : "Vyberte prosím dodavatele, za kterého přijímáte toto pozvání.",
      "emptySuggestedProvider" : "Vyberte prosím doporučeného dodavatele ze seznamu."
    },
    "attachment" : {
      "documentAdded" : "Dokument __filename__ přiložen.",
      "documentsAdded" : "Dokumenty __filenames__ přiloženy.",
      "documentRemoved" : "Dokument __filename__ odebrán.",
      "documentsRemoved" : "Dokumenty __filenames__ odebrány."
    },
    "annexes" : {
      "estimatedDuration" : "Odhadované trvání",
      "price" : "Cena",
      "project" : "Projekt",
      "changeType" : "Změnit typ",
      "changeSeverity" : "Změnit závažnost",
      "assignSolver" : "Přiřadit řešitele",
      "addAttachment" : "Přidat přílohu"
    },
    "changes" : {
      "assignedSolver" : "Uživatel __newSolver__ byl přiřazen jako řešitel požadavku.",
      "changedSolver" : "Řešitel požadavku byl změněn z __oldSolver__ na __newSolver__.",
      "durationSet" : "Odhadované trvání bylo nastaveno na __duration__.",
      "durationCleared" : "Odhadované trvání __duration__ bylo odstraněno.",
      "durationChanged" : "Odhadované trvání bylo změněno z __oldDuration__ na __newDuration__.",
      "priceSet" : "Cena byla nastavena na __price__.",
      "priceCleared" : "Cena __price__ byla odstraněna.",
      "priceChanged" : "Cena byla změněna z __oldPrice__ na __newPrice__.",
      "projectSet" : "Projekt '__project__' byl přiřazen.",
      "projectCleared" : "Projekt '__project__' byl odstraněn.",
      "projectChanged" : "Projekt byl změněn z '__oldProject__' na '__newProject__'.",
      "providerSet" : "Dodavatel '__provider__' byl nastaven.",
      "providerCleared" : "Dodavatel '__provider__' byl odebrán.",
      "providerChanged" : "Dodavatel se změnil z '__oldProvider__' na '__newProvider__'.",
      "severityIncreased" : "Vážnost požadavku se zvýšila z __oldValue__ na __newValue__.",
      "severityDecreased" : "Vážnost požadavku se snížila z __oldValue__ na __newValue__.",
      "taxSet" : "Daň byla nastavena na __tax__.",
      "taxCleared" : "Daň __tax__ byla odstraněna.",
      "taxChanged" : "Daň se změnila z __oldTax__ na __newTax__.",
      "typeChanged" : "Typ požadavku se změnil z '__oldValue__' na '__newValue__'."
    },
    "suggestedProvider" : {
      "oneAdded" : "Přidán __provider__ jako doporučený dodavatel.",
      "moreAdded" : "Přidáni __providers__ jako doporučení dodavatelé.",
      "oneRemoved" : "Doporučený dodavatel __provider__ odstraněn.",
      "moreRemoved" : "Doporučení dodavatelé __providers__ odstraněni."
    },
    "inviteProvider" : {
      "rejectComment" : "Omlouvám se, ale nemohu Vám pomoci.",
      "acceptComment" : "Děkuji a přijímám Vaše pozvání.",
      "suggestComment" : "Děkuji za pozvání, nicméně nejsem si jistý, že jsem vhodným dodavatelem pro tento požadavek. Rád Vám však doporučím nějakoho jiného."
    },
    "uploadFailed" : "Soubor '__filename__' nemohl být nahrán.\nUjistěte se prosím, že soubor je čitelný a není prázdný."
  },
  "personDetail" : {
    "title" : "Atollon - osobní stránky __person__",
    "headerText" : "Osobní stránky __person__",
    "notRegisteredHeader" : "Tento uživatel zatím nebyl registrován",
    "waitingForMe" : "Čeká na mě",
    "waitingforThem" : "Čeká na ně",
    "contactMe" : "Kontaktujte mne"
  },
  "providerHome" : {
    "title" : "Atollon - Vítejte na stránce __company__",
    "headerText" : "Vítejte na stránce __company__",
    "waitingForMe" : "Čeká na mě",
    "waitingforThem" : "Čeká na ně",
    "sharedProjectsAdnFolders" : "Sdílené projekty a složky",
    "createNewProject" : "Vytvořit nový projekt",
    "contactUs" : "Kontaktujte nás"
  },
  "newOrganization" : {
    "title": "Atollon - Vytvořit účet organizace",
    "headerText": "Vytvořit účet organizace",
    "verifyDomain" : "Verify Domain",
    "organizationDetails" : "Organization Details",
    "features" : {
      "title" : "Založit nový účet poskytovatele",
      "head1" : "Budujte důvěru u svých klientů",
      "desc1" : "Staňte se více transparentní a ukažte jim, že se staráte.",
      "head2" : "Racionalizujte dodání práce",
      "desc2" : "Racionalizujte proces dodávky služeb vysoké kvality.",
      "head3" : "Vydělejte více peněz",
      "desc3" : "Transparentní dodání vaší práce zvýší šanci, že dostanete zaplaceno rychleji.",
      "footer" : "Začněte s účtem zdarma a povyšte ho, pokud to bude potřeba."
    },
    "hostName" : {
      "label" : "Vaše doména",
      "hint" : "Zadejte název domény vaší organizace.",
      "placeholder" : "moje.doména.cz"
    },
    "hostEmail" : {
      "label" : "Ověřte vlastnictví vaší domény",
      "hint" : "Vyberte prosím e-mailovou adresu, na kterou můžeme zaslat požadavek o potvrzení."
    },
    "detailsForm" : {
      "title" : "Detaily organizace",
      "confirm" : "Potvrzuji, že jsem oprávněn jednat za výše uvedenou organizaci a spouhlasím s podmínkami provozu."
    },
    "requestSubject" : "Vytvořit účet organizace",
    "requestBody" : "Založte prosím organizaci '__organization__' a nastavte uživatele s e-mailovou adresou '__sender__' jako správce organizace.",
    "badRequest" : {
      "message" : "Požadavek nemohl být vytvořen.",
      "description" : "Prosím ověřte, že veškeré hodnoty jsou správné."
    },
    "invalidForm" : {
      "message" : "Neplatné hodnoty",
      "description" : "Ve formuláři jsou zadané neplatné hodnoty."
    },
    "noEmail" : {
      "message" : "Nebyl vybrán e-mail",
      "description" : "Vyberte prosím e-mailovou adresu, na kterou bude zaslán požadavek."
    },
    "invalid" : {
      "hostName" : "Zadán neplatný název domény.",
      "hostNameCheck" : "Kontroluji, zda-li název domény již existuje.",
      "hostNameExists" : "Tento název domény je již registrován.",
      "hostNameNotAllowed" : "Tento název domény není povolen.",
      "email" : "Vyberte jednu z e-mailových adres.",
      "organizationName" : "Název organizace je vyžadován.",
      "address" : "Adresa je vyžadována.",
      "city" : "Město je vyžadováno.",
      "zip" : "PSČ je vyžadováno.",
      "country" : "Vyberte ze seznamu zemi.",
      "companyIndustry" : "Vyberte ze seznamu obor firmy.",
      "webAddress" : "Webová adresa má neplatný formát.",
      "confirm" : "Musíte potvrzdit, že souhlasíte s Podmínkami provozu."
    }
  },
  "createOrganization" : {
    "title" : "Atollon - Potvrzení žádosti o správu organizace",
    "headerText" : "Potvrzení žádosti o správu organizace",
    "contents" : {
      "0" : "Odesílatel",
      "1" : "se chce stát správcem organizace",
      "2" : "na Atollon.com"
    },
    "notice" : "Potvrzením tohoto požadavku zpřístupníte odesílateli (__sender__) plná práva k účtu organizace (__account__).",
    "warning" : "Odmítněte prosím požadavek, pokud nepoznáváte e-mailovou adresu odesílatele nebo nechcete zpřístupnit odesílateli plná práva k organizaci.",
    "invalidUrl" : {
      "title" : "Neplatné URL",
      "description" : "Pokud jste se sem dostal(a) z odkazu v e-mailové zprávě, tak byl tento odkaz patrně použit a již není platný."
    },
    "accept" : {
      "title" : "Požadavek na správu byl akceptován",
      "content" : "Požadavek na správu organizace __organization__ uživatele __sender__ byl přijat. Odesílatel požadavku byl upozorněn."
    },
    "reject" : {
      "title" : "Požadavek na správu byl odmítnut",
      "content" : "Požadavek spravovat organizaci __organization__ uživatele __sender__ byl odmítnut. Odesílatel požadavku byl upozorněn."
    },
    "button" : {
      "setup" : "Nastavení organizace",
      "home" : "Stránka organizace"
    },
    "requestRejected" : "Požadavek na vytvoření organizace byl zamítnut.",
    "requestConfimed" : "Požadavek na vytvoření organizace byl vyřešen a organizace byla založena. Odesílatel požadavku byl upozorněn."
  },
  "settings" : {
    "title" : "Atollon - Nastavení",
    "headerText" : "Nastavení",
    "accountSettings" : "Nastavení účtu",
    "organizationSettings" : "Nastavení organizace",
    "specificOrganizationSettings" : "Nastavení organizace __organization__",
    "identification" : "Identifikace",
    "basicAccountInfo" : "Základní informace o účtu",
    "profilePicture" : "Obrázek profilu",
    "administratorOf" : "Organizace, ve kterých jsem správcem",
    "dispatcherOf" : "Organizace, ve kterých jsem dispečerem",
    "memberOf" : "Organizace, kterých jsem členem",
    "legalEntityDetails" : "Detaily subjektu",
    "companyLogoAndThumb" : "Logo firmy a ikonka",
    "validation" : {
      "relationshipExists" : "Vztah již existuje.",
      "customTypeExists" : "Stejná hodnota vlastního typu již existuje.",
      "severityExists" : "Stejná hodnota závažnosti již existuje.",
      "passwordsDoNotMatch" : "Nová hesla nesedí."
    },
    "administrators" : {
      "title" : "Správci",
      "remove" : "Odebrát správce",
      "empty" : "Tato organizace nemá žádné správce.",
      "inviteNew" : "Pozvat nového správce..."
    },
    "dispatchers" : {
      "title" : "Dispečeři",
      "remove" : "Odebrat dispečera",
      "empty" : "Tato organizace nemá žádné dispečery.",
      "inviteNew" : "Pozvat nového dispečera…"
    },
    "apiKeys" : {
      "title" : "API klíče",
      "remove" : "Odebrat klíč",
      "empty" : "Žádné API klíče nejsou přiřazeny.",
      "addNew" : "Přidat nový API klíč..."
    },
    "requestTypes" : {
      "title" : "Vlastní typy požadavků",
      "remove" : "Odebrat vlastní typ",
      "empty" : "Žádné vlastní typy nejsou zadány.",
      "addNew" : "Přidat nový vlastní typ...",
      "removeConfirm" : {
        "message" : "Jste si jistý(á), že chcete __type__ odebrat z vlastních typů?",
        "description" : "Uživatel nebude moci vytvořit nový požadavek tohoto typu. Existující požadavky tohoto typu nebudou změněny."
      }
    },
    "requestSeverities" : {
      "title" : "Vážnosti požadavků",
      "remove" : "Odebrat vážnost",
      "empty" : "Nejsou určeny žádné vážnosti.",
      "addNew" : "Přidat novou vážnost...",
      "removeConfirm" : {
        "message" : "Jste si jist(á), že chcete odebrat vážnost __severity__ ze seznamu?",
        "description" : "Uživatel nebude moci vytvořit nový požadavek s takovou vážností, ačkoliv stávající požadavky nebudou změněny."
      }
    },
    "uploadProfilePicture" : "Nahrát profilový obrázek",
    "uploadOrganizationThumbnail" : "Nahrát firemní ikonku",
    "uploadOrganizationLogo" : "Nahrát firemní logo",
    "uploadFileSupport" : "Vyberte obrázek typu JPEG, GIF, PNG nebo BMP.",
    "emptyOrganizations" : "Nejste ani správce, ani dispečer žádné organizace.",
    "invalidForm" : {
      "message" : "Nemohu uložit form.",
      "description" : "Nemohu uložit formulář, jelikož není správně vyplněn."
    },
    "removeAdminConfirm" : {
      "message" : "Jste si jist(á), že chcete odstranit správce __admin__?",
      "description" : "Uživatel nebude moci nadále spravovat tuto organizaci."
    },
    "removeDispatcherConfirm" : {
      "message" : "Jste si jist(á), že chcete odebrat dispečera __dispatcher__?",
      "description" : "Uživatel již nezíská přístup k požadavkům adresovaným na tuto organizaci."
    },
    "removeApiKeyConfirm" : {
      "message" : "Jste si jist(á), že chcete odebrat API klíč?",
      "description" : "Kdokoli, kdo nyní používá tento klíč, ho již nebude moci nadále využívat."
    },
    "changePasswordHeader" : "Změna hesla",
    "passwordChanged" : {
      "message" : "Heslo změněno",
      "description" : "Heslo bylo úspěšně změněno. Až se budete znovu přihlašovat, použijte nové heslo."
    },
    "wrongOldPassword" : {
      "message" : "Heslo nemohlo být změněno.",
      "description" : "Staré heslo není správné. Prosím zadejte správné staré heslo."
    }
  }
};

export default  //const TranslationOld =
{
    getTranslationForKey: ( key, subst ) =>
    {
        const keys = key.split(".");
        let t = translation;
        for( let i = 0; i < keys.length; i++ )
        {
            t = t[keys[i]];
        }
        if( subst )
        {
          forEach( subst, (value,key) =>
          {
            t = t.replace( `__${key}__`, value );
          })
        }
        return t;
    },
};


// WEBPACK FOOTER //
// ./src/pages/RequestDetail/translation_old_cs.js